import { render } from "./ModalAR.vue?vue&type=template&id=52d6c250&scoped=true"
import script from "./ModalAR.vue?vue&type=script&lang=js"
export * from "./ModalAR.vue?vue&type=script&lang=js"

import "./ModalAR.vue?vue&type=style&index=0&id=52d6c250&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d6c250"]])

export default __exports__